<template>
  <div>
    <h2 v-if="withHeader" class="mb-4 text-heading-3-desktop text-black-78">Informacije o ceni in lokaciji</h2>
    <figure>
      <div
        class="h-[220px] sm:h-[200px] w-full rounded-3xl lg:h-[320px] lg:bg-white lg:p-11 lg:shadow flex flex-col justify-between">

        <div class="text-body-regular text-black-40">
          Vrednost kvadratnega metra te nepremičnine v primerjavi s cenami nepremičnin v okolici.
        </div>

        <div>
          <!-- bar with gradient - linear-gradient(90deg, #A1C1BB 0%, #EBF9AE 50.52%, #FA7268 100%); -->
          <div class="relative rounded-full h-5 w-full bg-gradient-to-r from-[#A1C1BB] via-[#EBF9AE] via-50% to-[#FA7268]">
            <div class="absolute flex flex-col bottom-16 lg:bottom-[4.75rem]"
                :class="indicatorProcents < comparedProcents ? 'ml-9 lg:ml-16' : 'mr-9 lg:mr-16'"
                :style="textPosition">
              <label class="text-black-78 text-body-regular lg:text-body mb-1 lg:mb-0">{{ labelText }}</label>
              <span class="text-green text-heading-4-bold lg:text-heading-3-desktop">{{ $filters.formatNumber(perSquareMeterPrice) }} €/m²</span>
            </div>
            
            <!-- dot with image and line -->
            <div class="absolute transform -translate-x-1/2 bottom-0 flex flex-col items-center"
                :style="{ 'left': `${indicatorProcents}%` }">
              <div class="w-12 h-12 lg:w-20 lg:h-20">
                <img :src="`/assets/images/${imageUrlTitle}.webp`" alt="">
              </div>
              <div class="w-px h-7 bg-black-40 my-2"></div>
              <div class="h-5 w-5 rounded-full bg-white shadow-search"></div>
            </div>
          </div>
          
          <div class="flex justify-between text-small-text-regular text-black-40 font-medium mt-4">
            <div>
              {{ $filters.formatNumber(minPrice) }} €/m²
            </div>
            <div>{{ $filters.formatNumber(maxPrice) }} €/m²</div>
          </div>
        </div>
      </div>
    </figure>
  </div>
</template>

<script>
export default {
  name: "ListingPriceInformation",

  props: {
    minPrice: {
      type: Number,
      required: true
    },
    maxPrice: {
      type: Number,
      required: true
    },
    perSquareMeterPrice: {
      type: Number,
      required: true
    },
    property: {
      type: String,
      required: true
    },
    withHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
    };
  },
  
  computed: {
    comparedProcents() {
      return this.$root.isMobileViewport ? 50 : 60;
    },

    indicatorProcents() {
      // Position indicator on the bar
      const min = this.minPrice;
      const max = this.maxPrice;
      const perSquareMeterPrice = this.perSquareMeterPrice;
      
      return (perSquareMeterPrice - min) / (max - min) * 100;
    },

    textPosition() {
      return this.indicatorProcents < this.comparedProcents 
        ? { left: `${this.indicatorProcents}%` } 
        : { right: `${100 - this.indicatorProcents}%` };
    },

    labelText() {
      const properties_check = ['Stanovanje'] // Add additonal properties here which should spell To
      const preText = properties_check.includes(this.property) ? 'To' : 'Ta'
      
      return `${preText} ${this.property.toLowerCase()}`
    },

    imageUrlTitle() {
      switch (this.property) {
        case 'Stanovanje':
          return 'stanovanje_3'
        case 'Novogradnja stanovanje':
          return 'stanovanje_3'
        case 'Hiša':
          return 'hisa_3'
        case 'Novogradnja hiša':
          return 'hisa_3'
        case 'Parcela':
          return 'parcela'
        case 'Soba':
          return 'soba_3'
        default:
          return 'hisa_3'
      }
    }
  }
};
</script>


<!-- 
  {
   "rating":{
	  // Cena ki smo jo poslali na arvio
      "input_price":18000000,
	  // V kater rating range spada ta oglas (rating_id v spodnjem arrayju)
      "rating_id":5,
	  // Ocenjena vrednost nepremičnine
      "estimated_price":297455.79218,
	  // Ocenjena vrednost na m2
      "estimated_price_m2":1487.2789609,
	  // Kaj je blo upoštevano za oceno, pomoje ne rabmo tega?
      "aspects":{...}
   },
   "rating_range":[
      {
		 // Rang cene od do
         "price_range":[
            0,
            126704.25476582907
         ],
		 // Range cene od do na m2
         "price_range_m2":[
            0,
            633.5212738291453
         ],
		 // Rang v besedilu
         "price_range_text":"1 \u2014 126.704 \u20ac",
		 // Opis
         "rating_text":"Ugodna cena",
		 // Id (referenca ne to je iz zgornjega rating arraya)
         "rating_id":1
      },
      {
         "price_range":[
            126704.25476582907,
            166513.47064515873
         ],
         "price_range_m2":[
            633.5212738291453,
            832.5673532257937
         ],
         "price_range_text":"126.705 \u2014 166.513 \u20ac",
         "rating_text":"Dobra cena",
         "rating_id":2
      },
      {
         "price_range":[
            166513.47064515873,
            214013.98950139887
         ],
         "price_range_m2":[
            832.5673532257937,
            1070.0699475069944
         ],
         "price_range_text":"166.514 \u2014 214.013 \u20ac",
         "rating_text":"Po\u0161tena cena",
         "rating_id":3
      },
      {
         "price_range":[
            214013.98950139887,
            308703.8852325751
         ],
         "price_range_m2":[
            1070.0699475069944,
            1543.5194261628756
         ],
         "price_range_text":"214.014 \u2014 308.703 \u20ac",
         "rating_text":"Povi\u0161ana cena",
         "rating_id":4
      },
      {
         "price_range":[
            308703.8852325751,
            18000020
         ],
         "price_range_m2":[
            1543.5194261628756,
            90000.1
         ],
         "price_range_text":"308.704 \u2014 18.000.020 \u20ac",
         "rating_text":"Visoka cena",
         "rating_id":5
      }
   ]
}

 -->